module.exports = __webpack_public_path__ + "static/mtb-12-20216b53ddb8110eeee651c246bc4809.jpg";